module.exports = __webpack_public_path__ + "img/ChatBot.22d5fe91.jpg";